import React from "react"
import Typography from "aldoo-ra/Typography"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"

const UpdateListDialog = ({
  isOpen,
  onClose,
  updates,
  onUpdate,
  isUpdating,
}) => {
  const sortedUpdates = (updates || []).sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  )


  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      variant="admin_centered"
    >
      <div className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <Typography variant="admin_h4">
            {isUpdating ? "Updating..." : "Available Updates"}
          </Typography>

          <span className="text-sm text-admin_text_secondary bg-admin_primary/10 rounded-full px-3 py-1">
            {updates?.length || 0} updates
          </span>
        </div>

        <div className="max-h-96 overflow-y-auto">
          {sortedUpdates.map((update, index) => (
            <div
              key={index}
              className={`hover:bg-admin_primary/5 transition-colors p-3 ${
                index !== 0 && "border-t border-admin_bordered"
              }`}
            >
              <div className="flex justify-between items-start gap-4">
                <Typography 
                  variant="admin_body" 
                  className="break-words flex-1 my-0">
                  {update.subject}
                </Typography>

                <div className="flex flex-col text-right flex-shrink-0">
                  <Typography 
                    variant="admin_body_dim" 
                    className="whitespace-nowrap my-0"
                  >
                    {new Date(update.date).toLocaleString()}
                  </Typography>

                  <Typography 
                    variant="admin_txt1_dim" 
                    className="whitespace-nowrap"
                  >
                    {update.author}
                  </Typography>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button 
            variant="admin_secondary" 
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button 
            variant="admin_primary" 
            onClick={onUpdate} disabled={isUpdating}
          >
            Update
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default UpdateListDialog
